import React, { useEffect, useRef } from 'react'
import { App_url, collectionItems } from '../utils/constants/static'
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);
const Collection = () => {
  const titleRef = useRef<HTMLDivElement>(null);
  const sectionRef = useRef<HTMLDivElement>(null);
  const horizontalRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const title = titleRef.current;
    const section = sectionRef.current;
    const horizontal = horizontalRef.current;


    if (!title || !section || !horizontal) return;

    const letters = title?.querySelectorAll('.letter');
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: section,
        start: "top top",
        end: "+=300",
        // markers: true,
        scrub: 0.8,
      }
    });

    tl.fromTo(letters,
      { y: 100, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        duration: 2,
        stagger: {
          each: 0.1,
          from: "center"
        },
        ease: "power3.out",
      }, 0);  

    // 2. Cards fade in simultaneously with letters (slightly delayed)
    // gsap.utils.toArray<HTMLElement>(horizontal.children).forEach((card, i) => {
    //   tl.fromTo(
    //     card,
    //     { opacity: 0, y: 60 },
    //     {
    //       opacity: 1,
    //       y: 0,
    //       duration: 1.1,
    //       ease: 'power3.out',
    //     },
    //     0.2 + i * 0.08 // slight stagger per card
    //   );
    // });
    const totalWidth = horizontal.scrollWidth;
    const viewportWidth = window.innerWidth;
    const scrollDistance = totalWidth! - viewportWidth;

      

    gsap.to(horizontal, {
      x: -scrollDistance,
      ease: "none",
      duration: 5,
      scrollTrigger: {
        trigger: section,
        start: "top top-=50",
        end: `+=${scrollDistance + 500}`,
        pin: true,
        // markers: true,
        scrub: 1,
      }
    });

    const items = horizontal.querySelectorAll('.parallax-item');
    items.forEach((item) => {
      const img = item.querySelector('img');
      const text = item.querySelector('.para');
      gsap.to([img, text], {
        x: "-50%",
        ease: "none",
        scrollTrigger: {
          trigger: section,
          start: "top top",
          end: `+=${scrollDistance}`,
          scrub: 1,
        }
      })
    });

    return () => ScrollTrigger.getAll().forEach((t) => t.kill());
  }, [])

  const titleLetters = "COLLECTION".split("");

  const groups = [
    {
      items: collectionItems.slice(0, 3),
      gridClasses: "!max-w-none grid [grid-template-columns:calc(100vw_-_(var(--svg-height)*148/80)*2)_1fr_calc(var(--svg-height)*148/80_-_10vw)_10vw] [grid-template-rows:56%_44%] gap-0 w-[100vw] h-full",
      imageClasses: ["", "col-start-3 col-end-5 aspect-[2/1]", "col-start-2 col-end-4 h-full"]
    },
    {
      items: collectionItems.slice(3, 6),
      gridClasses: "!max-w-none grid [grid-template-columns:1fr_1fr_1fr_calc(var(--svg-height)*148/80_-_10vw)_10vw] [grid-template-rows:56%_44%] gap-0 w-[100vw] h-full pl-[20vw] pr-[15vw]",
      imageClasses: ["col-start-1 aspect-[3/4] h-full", "col-start-2 col-end-5 row-start-2 aspect-[3/2] h-full", "col-start-4 col-end-6 aspect-[2/1]"]
    }
  ]
  return (
    <div ref={sectionRef} id='collection' className='bg-black h-[100vh] w-full relative overflow-hidden'>
      <div className='absolute z-10 inset-0 flex justify-center items-center mix-blend-difference'>
        <h1 ref={titleRef} className='overflow-hidden text-white text-8xl font-[PPEiko] font-light'>
          {titleLetters.map((char, index) => (
            <span key={index} className="letter inline-block">
              {char === " " ? "\u00A0" : char}
            </span>
          ))}
        </h1>
      </div>


      {/* horizontal scroll view */}
      <div ref={horizontalRef} className="!max-w-none flex flex-row h-[100vh] w-fit pt-[10%] pb-[20px]">
        {groups.map((group, i) => (
          <div key={i} className={group.gridClasses}>
            {group.items.map((item, j) => (
              <div
                key={item.id}
                className={`parallax-item ${group.imageClasses[j]} !max-w-none relative flex justify-end`}
              >
                <div className={`${item.classes} para absolute z-10 right-[-16px] w-0 whitespace-nowrap text-white uppercase font-light`}>
                  <div className="text-base">0{item.id}</div>
                  <div className="text-base">{item.title}</div>
                </div>
                <div className="w-full h-full overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    width={item.width}
                    height={item.height}
                    className="w-full h-full object-cover"
                  />
                </div>

              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  )
}

export default Collection
